import { Injectable } from '@angular/core';

// import { GraphQLResult, generateClient } from 'aws-amplify/api';

// import { graphqlOperation } from '@aws-amplify/api-graphql';
import { RncUsersModel, cpRnUserModel } from '../../model/user.model';
import {
  checkUserAccessControlQueries,
  cpUserAccessControlQueries,
  createUACQueries,
  filterByUserType,
  findUserQueries,
  updateUACQueries,
} from '../../graphql/user.queries';
import { AppConstants } from './app-constants';
import { environment } from '../../../../../../environments/environment';

//const client = generateClient();

import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult, } from "aws-amplify/lib/API/types";



let myAppConfig = environment.myAppConfig;

Amplify.configure(myAppConfig);

//createOrUpdateCpRnUser
@Injectable({
  providedIn: 'root',
})
export class UserService {
  private QUERY_KEY = {
    create_user: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createOrUpdateRncUsers}`,
    list_user: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listRncUsers}`,

    createcpAssignedRNUser: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createCpRnUser}`,
    updatecpAssignedRNUser: `${AppConstants.update}${environment.dbPrefix}${AppConstants.UpdateCpRnUser}`,
    list_cpAssignedRNUser: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpRnUser}`,
  };
  /*****************************************************************************
   * RN USER - USER ACCESS CONTROL
   ****************************************************************************/

  public async filterByUser(userName?: string): Promise<RncUsersModel> {
    console.log('GET_DATA', userName);
    // Example usage
    const querylist = this.QUERY_KEY.list_user;
    console.log('queryExplorer', querylist);

    try {
      const operation = graphqlOperation(findUserQueries.query, {
        user_name: userName,
      });

      // const response: GraphQLResult<{
      //   listRncUsers: RncUsersModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('USER_RESPONSE:', response); // Log the entire response

      if (response.data) {
        console.log('USER_DATA:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  public async filterByUserType(nextToken: any,
    limit: any, userType?: any): Promise<RncUsersModel> {
    console.log('GET_DATA', userType);
    // Example usage
    const querylist = this.QUERY_KEY.list_user;
    console.log('queryExplorer', querylist);

    try {
      const operation = graphqlOperation(filterByUserType.query, {
        nextToken: nextToken,
        limit: limit,
        user_type: userType,
      });

      // const response: GraphQLResult<{
      //   listRncUsers: RncUsersModel;
      // }> = (await client.graphql(operation)) as any;


      const response = await API.graphql(operation) as GraphQLResult;

      console.log('USER_RESPONSE:', response); // Log the entire response

      if (response.data) {
        console.log('USER_DATA:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching car request status:', error);
      throw error;
    }
  }

  /*****************************************************************************
   * CAP ASSIST - USER ACCESS CONTROL
   ****************************************************************************/

  public async cpUserAccessControlList(): Promise<cpRnUserModel> {
    const querylist = this.QUERY_KEY.list_cpAssignedRNUser;
    console.log('queryExplorer', querylist);
    try {
      const operation = graphqlOperation(cpUserAccessControlQueries.query, {});

      // const response: GraphQLResult<{
      //   querylist: cpRnUserModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data cap assits assigned rnuser.'
        );
      }
    } catch (error) {
      console.error('Error fetching CapAssit RNuser request status:', error);
      throw error;
    }
  }

  public async checkUserAccessControlByUser(
    userId: any
  ): Promise<cpRnUserModel> {
    const querylist = this.QUERY_KEY.list_cpAssignedRNUser;
    console.log('queryExplorer', querylist);
    try {
      const operation = graphqlOperation(checkUserAccessControlQueries.query, {
        user_name: userId,
      });

      // const response: GraphQLResult<{
      //   querylist: cpRnUserModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data cap assits check rnuser.'
        );
      }
    } catch (error) {
      console.error('Error fetching cap assits check rnuser status:', error);
      throw error;
    }
  }

  public async createUserAccessControl(
    createdObj: any
  ): Promise<cpRnUserModel> {
    const querylist = this.QUERY_KEY.createcpAssignedRNUser;
    console.log('queryExplorer', querylist);
    try {
      const operation = graphqlOperation(createUACQueries.mutation, {
        user_name: createdObj.user_name,
        name: createdObj.name,
        email: createdObj.email,
        phone: createdObj.phone,
        assign_mode: createdObj.assign_mode,
        status: createdObj.status,
        ex_data: createdObj.ex_data,
        created_date: AppConstants.getlocalDateFormate(),
        updated_date: AppConstants.getlocalDateFormate(),
      });

      // const response: GraphQLResult<{
      //   querylist: cpRnUserModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data cap assits check create cprnuser.'
        );
      }
    } catch (error) {
      console.error('Error fetching cap assits check cprnuser creat:', error);
      throw error;
    }
  }

  public async updateUserAccessControl(updateObj: any): Promise<cpRnUserModel> {
    const querylist = this.QUERY_KEY.updatecpAssignedRNUser;
    console.log('queryExplorer', querylist);
    try {
      const operation = graphqlOperation(updateUACQueries.mutation, {
        id: updateObj.id,
        user_name: updateObj.user_name,
        name: updateObj.name,
        email: updateObj.email,
        phone: updateObj.phone,
        assign_mode: updateObj.assign_mode,
        status: updateObj.status,
        ex_data: updateObj.ex_data,
        updated_date: AppConstants.getlocalDateFormate(),
      });

      // const response: GraphQLResult<{
      //   querylist: cpRnUserModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult;

      console.log('Response:', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response

        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error(
          'GraphQL operation returned no data cap assits check create cprnuser.'
        );
      }
    } catch (error) {
      console.error('Error fetching cap assits check cprnuser creat:', error);
      throw error;
    }
  }
}
